import { useSelector } from "@xstate/react"
import { host_machine_actor } from "../App/main"
import { Button } from "../Components/Button"
import { style } from "typestyle"
import { Client_Event_Name } from "@quiz-buzz/common"

export function Modal_Popup() {

	const {
		modal_header, 
		modal_content, 
	} = useSelector(host_machine_actor, (state) => state.context)

	if (!modal_header) {
		return <></>
	}

	return (
		<div className={modal_backdrop_style}>
			<div className={modal_style}>
				<div className={modal_header_style}>{modal_header}</div>
				<div className={modal_content_style}>{modal_content}</div>
				<div className={modal_buttons_style}>
					<Button text="Confirm" button_style="Danger" onClick={() => host_machine_actor.send({ type: Client_Event_Name.confirm_cancel_game })} />
					<Button text="Back" onClick={() => host_machine_actor.send({ type: Client_Event_Name.dismiss_modal })} />
				</div>
			</div>
		</div>
	)
}

const modal_backdrop_style = style({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	zIndex: 30,
})

const modal_style = style({
	width: '85%',
	maxWidth: '24rem',
	padding: '1rem',
	border: '0.2em solid black',
	borderRadius: '0.8em',
	backgroundColor: 'white',
})

const modal_header_style = style({
	fontSize: '1.2em',
	marginBottom: '0.7rem',
})

const modal_content_style = style({
	fontSize: '1em',
	marginBottom: '1rem',
})

const modal_buttons_style = style({
	display: 'grid',
	gridTemplateColumns: '1fr 1fr',
	gap: '0.7rem',
})
